import { ILocation } from './types';

export class Location implements ILocation {
  id: string;

  work: boolean;

  constructor(parameters: ILocation) {
    this.id = parameters.id;
    this.work = parameters.work;
    this.flowersGift = parameters.flowersGift;
    this.articleDescription = parameters.articleDescription;
  }

  flowersGift?: boolean;

  articleDescription?: string;
}
